import { Injectable, signal } from '@angular/core';

export interface DayTarget {
  employeeId: number;
  /** yyyy-MM-dd */
  date: string;
}

/**
 * att_review_10: opens the employee-day drawer from any attendance screen ("Open day" row action).
 * The drawer itself (app-attendance-day-drawer) sits in the app shell and shows while `current()` is set.
 */
@Injectable({ providedIn: 'root' })
export class AttendanceDayDrawerService {
  readonly current = signal<DayTarget | null>(null);

  open(target: DayTarget): void {
    if (!target || !Number.isFinite(target.employeeId) || !/^\d{4}-\d{2}-\d{2}$/.test(target.date ?? '')) return;
    this.current.set({ employeeId: target.employeeId, date: target.date });
  }

  close(): void {
    this.current.set(null);
  }
}
